<template>
  <span v-if="isMyOrder">
    <small style="padding: 0.75rem;">Gesperrt*</small>
  </span>
  <b-button @click="claimJob" v-else-if="!claimed" variant="primary">
    Übernehmen
  </b-button>
  <b-button @click="cancelJob" v-else-if="isMine" variant="danger">
    Zurückgeben
  </b-button>
  <div v-else>
    Nicht mehr verfügbar
  </div>
</template>

<script>
import jobs from "@/api/jobs";
import {Vendor} from "@/utils/model";
import {hashString} from "@/utils/hashing";
import {mapState} from "vuex";
import uberConfig from "@/api/uberConfig";

export default {
  props: {
    vendor: {
      type: Vendor,
      required: true
    }
  },
  computed: {
    ...mapState('user', ['profile']),
    isMyOrder () {
      return this.vendor.name === this.profile.vendor
    }
  },
  data () {
    return {
      claimed: true,
      isMine: false,
      jobId: null,
    }
  },
  async created () {
    this.jobId = await this.computeJobId()
    jobs.addListener(this.jobId, this.jobListener)
  },
  methods: {
    async computeJobId () {
      const ids = [this.vendor.order.id, ...this.vendor.itemsIds]
      return await hashString(ids.join())
    },
    jobListener(docSnapshot) {
      this.isMine = docSnapshot.get('uid') === this.$store.state.user.user.uid
      this.claimed = docSnapshot.exists
    },
    async jobCanBeClaimed(orderCreatedAt) {
      const windows = await uberConfig.get()
      windows.current.start = Date.parse(windows.current.start)
      return windows.current.start <= orderCreatedAt
    },
    async claimJob() {
      const orderCreatedAt = this.vendor.order.createdAt
      const canBeClaimed = await this.jobCanBeClaimed(this.vendor.order.createdAt)
      if (!canBeClaimed ){
        const orderCreatedAtDate = (new Date())
        orderCreatedAtDate.setTime(orderCreatedAt)
        console.log(`Too late for this order ${orderCreatedAtDate.toISOString()}`)
        return this.$bvModal.show('error-modal')
      } if( this.vendor.deliveryItem === undefined) {
        console.log("No delivery item")
        return this.$bvModal.show('error-modal')
      }
      try {
        await jobs.claim(
            this.jobId,
            this.vendor.itemsIds,
            this.vendor.name,
            this.vendor.order.id,
            this.vendor.deliveryItem.id
        )
      } catch (error) {
        console.log(error)
        this.$bvModal.show('error-modal')
      }
    },
    async cancelJob() {
      try {
        await jobs.cancel(this.jobId)
      } catch (error) {
        this.$bvModal.show('error-modal')
      }
    }
  }
}
</script>